<div>
  <p>
    <strong>
      <span style="font-size: 16pt;">Android</span>
    </strong>
  </p>
  <p style="line-height: 16.8pt; background: white; margin: 0in 0in 12.0pt 0in;">
    <span style="font-size: 14.5pt; font-family: 'Gill Sans MT',sans-serif; color: #404040;">Coming Soon</span>
  </p>
  <p>
    <strong>
      <span style="font-size: 16pt;">iOS</span>
    </strong>
  </p>
  <p style="line-height: 16.8pt; background: white; margin: 0in 0in 12.0pt 0in;">
    <span style="font-size: 14.5pt; font-family: 'Gill Sans MT',sans-serif; color: #404040;">Coming Soon</span>
  </p>
</div>


// WEBPACK FOOTER //
// ./src/app/ui/apps-page/apps-page.component.html